import { atom } from 'jotai'

import type { TextVariables } from '~shared/rundown/rundown'

import type { TextVariableDto } from '../model/dtos'

const _variablesAtom = atom<TextVariables>({})

export const variablesAtom = atom<TextVariables, [TextVariables], void>(
  (get) => {
    return get(_variablesAtom)
  },
  (_get, set, variables) => {
    set(_variablesAtom, variables)
  },
)

export const getVariableAtom = atom<
  (key: string) => TextVariableDto | undefined
>((get) => {
  const variables = get(variablesAtom)

  return (key: string) => {
    const value = variables[key]

    if (!value) return

    return {
      key,
      value,
    }
  }
})

export const managingVariableKeyAtom = atom<string | null>(null)
